import { render, staticRenderFns } from "./PreemptedSoPopup.vue?vue&type=template&id=efa4c452"
import script from "./PreemptedSoPopup.vue?vue&type=script&lang=js"
export * from "./PreemptedSoPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports